import top from "./components/Top.vue";
import easy from "./components/Easy.vue";
import easyResult from "./components/EasyResult.vue";
import kotsu from "./components/Kotsu.vue";
import kotsuResult from "./components/KotsuResult.vue";
import mati from "./components/Mati.vue";
import matiResult from "./components/MatiResult.vue";
import sheet from "./components/Sheet.vue";
import drill from "./components/drill.vue";
import result from "./components/result.vue";

export const routes = [
  // path はルートパスからのアドレス
  // component は import したコンポーネントの名称
  {
    path: "/",
    component: top,
    name: "top",
  },
  {
    path: "/easy",
    component: easy,
    name: "easy",
  },
  {
    path: "/easyResult",
    component: easyResult,
    name: "easyResult",
  },
  {
    path: "/kotsu",
    component: kotsu,
    name: "kotsu",
  },
  {
    path: "/kotsuResult",
    component: kotsuResult,
    name: "kotsuResult",
  },
  {
    path: "/mati",
    component: mati,
    name: "mati",
  },
  {
    path: "/matiResult",
    component: matiResult,
    name: "matiResult",
  },
  {
    path: "/sheet",
    component: sheet,
    name: "sheet",
  },
  {
    path: "/drill",
    component: drill,
    name: "drill",
  },
  {
    path: "/result",
    component: result,
    name: "result",
  },
  // 404
  {
    path: "*",
    component: top,
    name: "FileNotFound",
  },
];
